// 签署

export default {
  path: '/sign',
  component: () => import('@/layout/Empty.vue'),
  meta: {
    layout: { pageWrap: false },
    personVerify: true,
    companyVerify: true
  },
  children: [
    {
      path: '/user/contractSendOut',
      component: () => import('@/views/user/template/contractSendOut.vue'),
      meta: {
        title: '发起签约',
        layout: { pageWrap: false }
      }
    },
    {
      path: '/signIssue/sign',
      name: 'sign',
      component: () => import('@/views/user/signIssue/sign/sign.vue'),
      meta: {
        title: '签署',
        layout: { subPage: true, pageWrap: false, name: 'empty' },
        checkSign: true
      }
    },
    {
      path: '/signIssue/batchSign',
      name: 'batchSign',
      component: () => import('@/views/user/signIssue/batchSign/batchSign.vue'),
      meta: {
        title: '批量签署',
        layout: { subPage: true, pageWrap: false },
        checkSign: true
      }
    },
    {
      path: '/signIssue/signinglocation',
      name: 'signinglocation',
      component: () => import('@/views/user/signIssue/signinglocation/signinglocation.vue'),
      meta: { title: '拖动签署位置', layout: { subPage: true, pageWrap: false, name: 'empty' } }
    },
    {
      path: '/signIssue/cappingSign',
      name: 'cappingSign',
      component: () => import('@/views/user/signIssue/cappingSign/cappingSign.vue'),
      meta: { title: '拖动签署位置', layout: { subPage: true, pageWrap: false, name: 'empty' } }
    },
    {
      path: 'signer',
      name: 'signer',
      component: () => import('@/views/user/sign/ContractSigner.vue'),
      meta: {
        title: '本地文件发起签署',
        layout: { subPage: true, pageWrap: false, name: 'empty' }
      }
    },
    {
      path: 'apply-for-seal',
      name: 'apply-for-seal',
      component: () => import('@/views/user/sign/ApplyForSeal.vue'),
      meta: {
        title: '用印申请',
        layout: { subPage: true, pageWrap: false, name: 'empty' }
      }
    }
  ]
}
